import parse, { domToReact } from 'html-react-parser'
import { Fragment, type ReactNode } from 'react'

import { Li, P } from '@/@bothrs-ui/web/components/typography/Body'
import { H1, H2, H3, H4 } from '@/@bothrs-ui/web/components/typography/Heading'
import { Link } from '@/@bothrs-ui/web/components/typography/Link'
import { ContentImage } from './media/ContentImage'

import type { DOMNode, Element } from 'html-react-parser'
import type { ContentBlock } from '@/modules/content/types/content.type'

function transform(domNode: DOMNode) {
  if (domNode.type !== 'tag') {
    return null
  }

  const element = domNode as Element

  if (domNode.name === 'img') {
    return <ContentImage src={element.attribs.src} alt={element.attribs.alt || ''} />
  }

  if (domNode.name === 'a') {
    return <Link to={element.attribs.href}>{domToReact(element.children as DOMNode[])}</Link>
  }

  if (domNode.name === 'h1') {
    return <H1>{domToReact(element.children as DOMNode[])}</H1>
  }

  if (domNode.name === 'h2') {
    return <H2>{domToReact(domNode.children as DOMNode[])}</H2>
  }

  if (domNode.name === 'h3') {
    return <H3>{domToReact(domNode.children as DOMNode[])}</H3>
  }

  if (domNode.name === 'h4') {
    return <H4>{domToReact(domNode.children as DOMNode[])}</H4>
  }

  if (domNode.name === 'p' || domNode.name === 'span') {
    return <P type='BodyLargeRegular'>{domToReact(domNode.children as DOMNode[])}</P>
  }

  if (domNode.name === 'li') {
    return <Li type='BodyLargeRegular'>{domToReact(domNode.children as DOMNode[])}</Li>
  }
}

export function serializeHTML(html: string): ReactNode {
  return (
    <Fragment key={html}>
      {parse(html, {
        replace: transform,
      })}
    </Fragment>
  )
}

export function serializeCMSContentBlock(contentBlock: ContentBlock, key: string | number): ReactNode {
  if (contentBlock.typeHandle === 'image') {
    return <ContentImage key={contentBlock.image?.id} src={contentBlock.image?.url} />
  }

  if (contentBlock.typeHandle === 'text' && !contentBlock.text) {
    return null
  }

  return (
    <Fragment key={key}>
      {parse(contentBlock.text!, {
        replace: transform,
      })}
    </Fragment>
  )
}
